import { buildDocumentTitle } from "@airange/shared/page-titles";
import { LOGIN_PATH, OIDC_CALLBACK_PATH } from "@airange/shared/oidc-routes";

export type CtfAdminPageTitleInput = {
  pathname: string;
  siteTitle: string;
  centerTitle: string;
  loginPageTitle: string;
  pageName?: string | null;
  defaultPageTitle?: string | null;
  routeTitle?: string | false | null;
};

type TitleResolver = { match: RegExp; labelId: string };

const pageTitleResolvers: TitleResolver[] = [
  { match: /^\/dashboard$/, labelId: "ctf.pages.dashboard.title" },
  { match: /^\/categories$/, labelId: "ctf.pages.categories.title" },
  { match: /^\/challenges$/, labelId: "ctf.pages.challenges.title" },
  { match: /^\/artifact-releases$/, labelId: "ctf.pages.artifactReleases.title" },
];

export function resolveCtfAdminPageTitleId(pathname: string): string | null {
  for (const item of pageTitleResolvers) {
    if (item.match.test(pathname)) return item.labelId;
  }
  if (pathname === LOGIN_PATH || pathname === OIDC_CALLBACK_PATH) return null;
  return "ctf.pages.notFound.title";
}

export function buildCtfAdminDocumentTitle(input: CtfAdminPageTitleInput): string {
  if (input.pathname === OIDC_CALLBACK_PATH || input.pathname === LOGIN_PATH) {
    return buildDocumentTitle({
      kind: input.pathname === LOGIN_PATH ? "login" : "callback",
      siteTitle: input.siteTitle,
      pageTitle: input.pathname === LOGIN_PATH ? input.loginPageTitle : "",
    });
  }

  const pageTitleCandidates = [
    input.pageName,
    input.defaultPageTitle,
    input.routeTitle,
  ]
    .map((item) => String(item || "").trim())
    .filter(Boolean)
    .filter((item) => item !== input.centerTitle && item !== input.siteTitle);

  return buildDocumentTitle({
    siteTitle: input.siteTitle,
    centerTitle: input.centerTitle,
    pageTitle: pageTitleCandidates[0] || input.centerTitle,
  });
}
